<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-header-image image="images/cambio-header.jpg" />
      <o-section-header title="Overzicht reservatie" />
      <o-section>
        <p><o-icon icon="check" /> Je gewenste wagen is beschikbaar.</p>
      </o-section>
      <o-section>
        <o-key-value label="Locatie" value="Gent" />
        <o-key-value label="Standplaats" value="Gent-Dampoort" />
        <o-key-value label="Wagenklasse" value="S Micro. autom. - 2 + 2 pl." />
        <o-key-value label="Vertrek" value="24/06/2019 - 11:00" />
        <o-key-value label="Aankomst" value="24/06/2019 - 17:00" />
        <o-key-value label="Verzekering" value="Volledige dekking" />
      </o-section>
      <o-section @click.native="showOverlay('costEstimate')">
        <o-text-input
          value="Wil je weten hoeveel je rit zal kosten?"
          :readonly="true"
          :chevron="true"
        />
      </o-section>
      <o-section>
        <o-text-input placeholder="Schrijf hier je persoonlijke referentie" />
      </o-section>
    </o-view>
    <o-pay-button label="Bevestig reservatie" to="/sales/car/cambio" />
    <o-overlay title="Kostprijs van je rit" ref="costEstimate">
      <template #form>
        <o-cost-estimate />
      </template>
    </o-overlay>
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OOverlay from '@/components/base/OOverlay.vue'
import OCostEstimate from '@/components/overlays/OCostEstimate.vue'
export default {
  name: 'CambioNewSummary',
  components: {
    OCostEstimate,
    OOverlay,
    OFavoriteToggle,
    OHeaderImage,
    OPayButton
  }
}
</script>
